export const getSatser = async (): Promise<BarnestipendSatser> => {
    const response = await fetch('/api/mt1535/satser/barnestipend');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface BarnestipendSatser {
    Ar: number;
    SATS_ST04_INNTEKTSGRENSE_DAGER_211_X: number;
    SATS_ST04_INNTEKTSGRENSE_EKTEFELLE: number;
    SATS_ST04_FORMUEGRENSE_ENSLIG: number;
    SATS_ST04_FORMUEGRENSE_GIFT: number;
    SATS_ST04_TRYGDEGRENSE_DAGER_211_X: number;
    SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN1_PER_MND: number;
    SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN2_PER_MND: number;
    SATS_ST01_SFS31_BELOPSSATS_PER_BARN_TRINN3_PER_MND: number;
}
